import React from 'react';
import styles from "./Login.css";
import Header from "../../components/features/login/Header";
import LoginSquare from '../../components/features/login/LoginSquare';
import TitleModule from '../../components/features/login/TitleModule';
import WelcomeLogin from '../../components/features/login/WelcomeLogin';

const Login = () => {
  return (
    <div className="login-page"> 
      <Header />
      <div className="login-container">
        <div className="login-left">
          <TitleModule />
        </div>
        <div className="login-right">
          <WelcomeLogin />
          <LoginSquare />
        </div>
      </div>
    </div>
  );
};

export default Login;
